import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { changePassword } from "../../core/api/authService";
import { getApiErrorMessage } from "../../core/utils/apiError";

const EMPTY = { oldPassword: "", newPassword: "", confirmPassword: "" };

const ChangePassword = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.oldPassword || !form.newPassword || !form.confirmPassword) {
      Swal.fire("Required", "Please fill in all password fields.", "warning");
      return;
    }
    if (form.newPassword.length < 6) {
      Swal.fire("Too short", "New password must be at least 6 characters.", "warning");
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      Swal.fire("Mismatch", "New password and confirmation do not match.", "warning");
      return;
    }

    setSaving(true);
    try {
      await changePassword({ oldPassword: form.oldPassword, newPassword: form.newPassword });
      Swal.fire({ toast: true, position: "top-end", icon: "success", title: "Password changed successfully", showConfirmButton: false, timer: 2000 });
      setForm(EMPTY);
    } catch (err) {
      Swal.fire("Error", getApiErrorMessage(err, "Failed to change password."), "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Change Password</h4>
            <h6>Update your account password</h6>
          </div>
          <div className="page-btn d-flex gap-2">
            <button className="btn btn-cancel" onClick={() => navigate("/dashboard")}>Back to Dashboard</button>
          </div>
        </div>

        <div className="card" style={{ maxWidth: 480 }}>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Current Password <span className="text-danger">*</span></label>
                <input type="password" className="form-control" value={form.oldPassword} onChange={set("oldPassword")} autoComplete="current-password" />
              </div>
              <div className="mb-3">
                <label className="form-label">New Password <span className="text-danger">*</span></label>
                <input type="password" className="form-control" value={form.newPassword} onChange={set("newPassword")} autoComplete="new-password" />
              </div>
              <div className="mb-3">
                <label className="form-label">Confirm New Password <span className="text-danger">*</span></label>
                <input type="password" className="form-control" value={form.confirmPassword} onChange={set("confirmPassword")} autoComplete="new-password" />
              </div>
              <div className="d-flex gap-2 justify-content-end">
                <button type="submit" className="btn btn-submit" disabled={saving}>
                  {saving ? "Saving..." : "Change Password"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
